import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBBox, MDBJumbotron } from 'mdbreact';
import { Form, Input, Button, Checkbox, Result } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL,api } from '../api';
import ban from '../img/4.png'
import Modaleditpass from './Modaleditpass';
import Loaddingsubmit from './expert/Loaddingsubmit';


export default class Home extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                dateopen:[],
                opensystem : true,
                loadding:false,
                onoff:true,

            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
          }


          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

          componentDidMount() {
            // const token = JSON.parse(localStorage.getItem('nameuser'));
            // if (localStorage.getItem('nameuser') == null) {
            //     window.location.href = '/'
            // } else {
              
            // }
    
            // setTimeout(() => {
               
            //   api.get('registercon/selectdateopen')
            //    .then(res => {
            //      console.log(res);
              
            //      const result =  res.data.filter((word) => word.type_dateopen	 === "ลงทะเบียน");
            
            //      const event = result[0].start_dateopen;
            //      const event2 = result[0].close_dateopen;

            //      const date = new Date();
            //      const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
            //      const dates = day+"-"+month+"-"+year ;
           
            //      const dateFrom = event;
            //      const dateTo = event2;
            //      const dateCheck = dates;
           
            //      const d1 = dateFrom.split("-");
            //      const d2 = dateTo.split("-");
            //      const c = dateCheck.split("-");
           
            //      const from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  
            //      const to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
            //      const check = new Date(c[2], parseInt(c[1])-1, c[0]);
            //      const checkshow = check >= from && check <= to;

            //       this.setState({ opensystem: checkshow})


            //    }) 
            //  }, 0);
    
          }



      
          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();

              this.setState({ loadding:true})
             const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
             datafrm.append("Username", this.state.value);
             datafrm.append("Psaaword", this.state.Psaaword);

      
         // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
          // .post("https://conference.kpru.ac.th/PHPAPI/select.php",datafrm)
          api.post("registercon/selectadmincon",datafrm)
           
           .then(res => {
             console.log("response: ", res)
             if (res.data.length !== 0) {
              return this.setState({
                loading: true,
              }),
               localStorage.setItem('nameuser', res.data[0].name_admin),
               localStorage.setItem('admin_type', res.data[0].status_admin),
               localStorage.setItem('iduser', res.data[0].id_admin),
              // window.location.href = '/psf/superadminhome'
               window.location.href = '/superadminhome'
              
  

             }else{

                                          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลของอาจารย์
                                          datafrm.append("txtemail", this.state.value);
                                          datafrm.append("txtpass", this.state.Psaaword);

                                          
                                          const user = {
                                          "txtemail": this.state.value,
                                          "txtpass": this.state.Psaaword
                                          };

                                          fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
                                          method: 'POST',
                                          body: JSON.stringify(user),
                                          headers: {
                                        
                                          }
                                        })
                                          .then(res => res.json())
                                          .then((res) => {
                                              console.log(res);
                                            //   if (res[0].loginstatus === "1" && res[0].employee_id === "000512" || res[0].employee_id === "000961" || res[0].employee_id === "001334" || res[0].employee_id === "001322" || res[0].employee_id === "000026" || res[0].employee_id === "000096" || res[0].employee_id === "000970" || res[0].employee_id === "001025" ) {
                                            if( res[0].loginstatus === "1"){

                                // const datafrm = new FormData(); //ข้อมูลอาจารย์
                                // datafrm.append("Username", this.state.value);
                                // datafrm.append("Psaaword", this.state.Psaaword);
                                // api.post("registercon/selectusercon",datafrm)
                                //   .then(res => {
                                //     console.log("response: ", res)
                                //     if (res.data.length !== 0) {
                                //     return this.setState({
                                //       loading: true,
                                //     }),
                                        this.setState({ loadding:false})


                                       localStorage.setItem('nameuser', res[0].frist_name+' '+res[0].last_name);
                                       localStorage.setItem('admin_type', 'user');
                                       localStorage.setItem('iduser', res[0].employee_id);
                                       localStorage.setItem('register_typemamber', '2');
                                       localStorage.setItem('prefix_name', res[0].prefix_name);
                                      // window.location.href = '/psf/Homeuser'
                                       window.location.href = '/Homeuser'



                                    }else{

                                              const datafrm = new FormData(); //สร้างฟอร์มสำหรับผู้ดูแลระบบ
                                              datafrm.append("Username", this.state.value);
                                              datafrm.append("Psaaword", this.state.Psaaword);
                                              api.post("registercon/selectadmintypepresent",datafrm)
                                                .then(res => {
                                                  console.log("response: ", res)
                                                  if (res.data.length !== 0) {
                                                  return this.setState({
                                                    loading: true,
                                                    loadding:false
                                                  }),
                                                  //this.setState({ loadding:false})
                                                    localStorage.setItem('nameuser', res.data[0].name_admin),
                                                    localStorage.setItem('admin_type', res.data[0].status_admin),
                                                    localStorage.setItem('iduser', res.data[0].id_admin),
                                                    localStorage.setItem('presentype_id', res.data[0].presentype_id),
                                                    localStorage.setItem('presentype_name', res.data[0].presentype_name),

                                                   // window.location.href = '/psf/superadmincheckadmintype'
                                                     window.location.href = '/superadmincheckadmintype'
                                                  }else{
                                                          const datafrm = new FormData(); //สร้างฟอร์มสำหรับบรรณาธิการ
                                                          datafrm.append("Username", this.state.value);
                                                          datafrm.append("Psaaword", this.state.Psaaword);
                                                          api.post("registercon/selectadminexpertbn",datafrm)
                                                            .then(res => {
                                                              console.log("response: ", res)
                                                              if (res.data.length !== 0) {
                                                              return this.setState({
                                                                loading: true,
                                                                loadding:false
                                                              }),
                                                             // this.setState({ loadding:false})
                                                                localStorage.setItem('nameuser', res.data[0].name_expertbn),
                                                                localStorage.setItem('admin_type', 'expertbn'),
                                                                localStorage.setItem('iduser', res.data[0].id_expertbn),
                                                                localStorage.setItem('iduser', res.data[0].id_expertbn),
                                                                localStorage.setItem('presentype_id', res.data[0].presentype_id),
            
                                                               // window.location.href = '/psf/expertbn'
                                                                window.location.href = '/expertbn'
                                                              }else{
            
                                                             
                                                                            const datafrm = new FormData(); //สร้างฟอร์มสำหรับบรรณาธิการ
                                                                            datafrm.append("Username", this.state.value);
                                                                            datafrm.append("Psaaword", this.state.Psaaword);
                                                                            api.post("registercon/selectadminexpert",datafrm)
                                                                              .then(res => {
                                                                                console.log("response: ", res)
                                                                                if (res.data.length !== 0) {

                                                                                        if (res.data.length !== 0) {
                                                                                          //ผู้ทรงคุณวุฒิในวันงาน
                                                                                          const datafrm = new FormData(); //สร้างฟอร์มสำหรับบรรณาธิการ
                                                                                          datafrm.append("Username", this.state.value);
                                                                                          datafrm.append("Psaaword", this.state.Psaaword);
                                                                                          api.post("registercon/selectexpertdordatepresent",datafrm)
                                                                                            .then(resd => {
                                                                                              console.log("response: ", resd)
                                                                                              if (resd.data.length !== 0 && resd.data[0].roompresent_statuslogin === '1') {
                                                                                                return this.setState({
                                                                                                  loading: true,
                                                                                                  }),
                                                                                                  localStorage.setItem('nameuser', resd.data[0].name_expert),
                                                                                                  localStorage.setItem('admin_type', 'expertpresent'),
                                                                                                  localStorage.setItem('iduser', resd.data[0].id_expert),
                                                                                                  localStorage.setItem('id_roompresent', resd.data[0].id_roompresent),
                                                                                                // localStorage.setItem('presentype_id', res.data[0].presentype_id),
                                                                                              
                                                                                                  window.location.href = '/csrm2025/system/expertpresent'

                                                                                              }else{
                                                                                                // this.setState({
                                                                                                //   modal: true
                                                                                                //   })

                                                                                                            const datafrm = new FormData(); //สร้างฟอร์มสำหรับบรรณาธิการ
                                                                                                            datafrm.append("Username", this.state.value);
                                                                                                            datafrm.append("Psaaword", this.state.Psaaword);
                                                                                                            api.post("registercon/selectexpertdordatepresentsm",datafrm)
                                                                                                              .then(resd => {
                                                                                                                console.log("response: ", resd)
                                                                                                                if (resd.data.length !== 0 && resd.data[0].roompresent_statussmlogin === '1') {
                                                                                                                  return this.setState({
                                                                                                                    loading: true,
                                                                                                                    }),
                                                                                                                    localStorage.setItem('nameuser', resd.data[0].name_expert),
                                                                                                                    localStorage.setItem('admin_type', 'expertpresentsm'),
                                                                                                                    localStorage.setItem('iduser', resd.data[0].id_expert),
                                                                                                                    localStorage.setItem('id_roompresentsm', resd.data[0].id_roompresentsm),
                                                                                                                  // localStorage.setItem('presentype_id', res.data[0].presentype_id),
                                                                                                                    window.location.href = '/csrm2025/system/expertpresentsm'
                  
                                                                                                                }else{
                                                                                                                  // this.setState({
                                                                                                                  //   modal: true
                                                                                                                  //   })
                                                                                                                          return this.setState({
                                                                                                                          loading: true,
                                                                                                                          loadding:false
                                                                                                                          }),
                                                                                                                         // this.setState({ loadding:false})
                                                                                                                          localStorage.setItem('nameuser', res.data[0].name_expert),
                                                                                                                          localStorage.setItem('admin_type', 'expert'),
                                                                                                                          localStorage.setItem('iduser', res.data[0].id_expert),
                                                                                                                        // localStorage.setItem('presentype_id', res.data[0].presentype_id),
                                                                                                                         // window.location.href = '/psf/expertexpsf'
                                                                                                                          window.location.href = '/expertexpsf'
                  
                  
                                                                                                                }})


                                                                                                      //   return this.setState({
                                                                                                      //   loading: true,
                                                                                                      //   }),
                                                                                                      //   localStorage.setItem('nameuser', res.data[0].name_expert),
                                                                                                      //   localStorage.setItem('admin_type', 'expert'),
                                                                                                      //   localStorage.setItem('iduser', res.data[0].id_expert),
                                                                                                      // // localStorage.setItem('presentype_id', res.data[0].presentype_id),
                                                                                                      //   window.location.href = '/csrm2025/system/expert'


                                                                                              }})
                                                                                                

                                                                                        }else{
                                                                                          this.setState({
                                                                                            modal: true
                                                                                            })
                                                                                             
                                                                                        }

                                                                                }else{
                              
                              
                                                                                  this.setState({
                                                                                  modal: true
                                                                                  })

                                                                                }
                                                                              })
                                                                // this.setState({
                                                                // modal: true
                                                                // })
                                                              }
                                                            })

                                                    // this.setState({
                                                    // modal: true
                                                    // })
                                                  }
                                                })

                                      //  this.setState({
                                      //  modal: true
                                      //  })
                                    }
                                  })

            //   this.setState({
            //     modal: true
               
            // })
             
             }
             // do something about response
           })

          }


    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }
    

    render() {
        return (
            <div className=" bg3" style={{ height: '95vh' }} >
                <MDBContainer >
                {/* <div className='mt-1'>
                  
                </div> */}

<br/>

                 <MDBJumbotron className="transbox">
                    <MDBRow  className='mt-1'>
                  
                    <MDBCol md="4">
                    </MDBCol>


{/* {this.state.opensystem === true?<>
  
</>:<>
<MDBCol md="4">
<h3>ระบบปิดรับลงทะเบียนแล้ว</h3>
<Result
    status="403"
    title="Sorry"
    subTitle="Sorry, you are not authorized to access this page."
    //extra={<Button type="primary">Back Home</Button>}
  />
</MDBCol>
</>} */}


 <MDBCol md="4">
                            <div >
                            <img src="https://e-student.kpru.ac.th/creditbank/static/media/logokpru.78cc9560.png" className="rounded mx-auto d-block w-50" alt="aligment" />
                           
                            <br/>
                            
                        <form onSubmit={this.handleSubmit}>
                         
                            <MDBBox tag="p" className="text-center"><h4><strong>เข้าสู่ระบบ</strong></h4></MDBBox>
                            <p className="h4 text-center ">KPRU-PSF</p>
                            <p className="h5 text-center "> การพัฒนาคุณภาพอาจารย์เพื่อส่งเสริมการบรรลุผลลัพธ์การเรียนรู้ตามมาตรฐานคุณวุฒิระดับอุดมศึกษา</p>
                          {this.state.onoff === false?<>
                          <p className='text-center'>ระบบปิดให้บริการในขณะนี้</p>
                          </>:<>
                          
                         
                                        <div className="grey-text">
                                        <MDBInput label="Username" icon="user" group type="text" validate error="wrong"
                                            success="right"  name="Username" value={this.state.value} onChange={this.handleChange} required/>

                                        <MDBInput label="Password" icon="key" group type="password" validate error="wrong"
                                            success="right" value={this.state.Psaaword} onChange={this.handleChange2} required />

                                        </div>

                                      {this.state.loadding === true ?<><Loaddingsubmit/></>:<>

                                        <div className="text-center">
                                        <MDBBtn outline color="info" type="submit" value="Submit" >
                                        เข้าสู่ระบบ
                                            <MDBIcon far icon="paper-plane" className="ml-1" />
                                        </MDBBtn><br/>
                                        <br/>
                                        </div>
                                      </>}  
                          </>}

                        </form>
                          {/* <Login/> */}
                           {/* {this.state.value}
                           {this.state.Psaaword} */}
                         {/* <div className="text-center">   <Modaleditpass /> </div> */}
                        </div> 
                        </MDBCol>

                     


                        <MDBCol md="4">
                       </MDBCol>
                                 
                    </MDBRow>
  </MDBJumbotron>
  
  {/* <br/> */}
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
        <MDBModalHeader toggle={this.toggle}>
        </MDBModalHeader>
        <MDBModalBody className="text-center">
         
        <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
         <h3>usermame หรือ password ไม่ถูกต้อง</h3>
         <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
        </MDBModalBody>
       
      </MDBModal>
                   
                    </MDBContainer>
                  
            </div>
        )
    }
}
